import { it, type Translations } from './translations/it'
import { en } from './translations/en'
import { fr } from './translations/fr'
import { es } from './translations/es'

export type Lang = 'it' | 'en' | 'fr' | 'es'
export type { Translations }

export const translations: Record<Lang, Translations> = {
  it,
  en,
  fr,
  es,
}
